<template>
  <v-chip
    class="ag-tag"
    :data-close="close"
    :data-disabled="disabled"
    :data-icon="!!icon.icon"
    :data-outlined="outlined"
    :data-small="small"
    :data-type="type"
    :data-readonly="readonly"
    @click.stop="onClick()"
  >
    <template #prepend>
      <AGIcon v-if="icon.icon" start :icon="icon.icon" :animation="icon.animation" :color="icon.color" />
    </template>

    {{ computedLabel }}

    <AGButtonIcon v-if="close" icon="md:clear" size="sm" :disabled="disabled" @click.stop="onClose" />
  </v-chip>
</template>

<script>
import AGButtonIcon from '@/components/common/AGButtonIcon.vue';
import AGIcon from '@/components/common/AGIcon.vue';
import { ModelIconProps } from '@/model/common/ModelIconProps';
import UtilsString from '@/utils/UtilsString';
import { uniqueId } from 'lodash';

export default {
  emits: ['click', 'click:close'],
  components: { AGIcon, AGButtonIcon },
  props: {
    id: {
      type: String,
      default: () => {
        return uniqueId('ag_tag_');
      },
    },

    small: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'default',
      validator: (val) =>
        ['default', 'info', 'success', 'warning', 'error', 'alert', 'notice', 'feature', 'primary'].includes(val),
    },

    /** @type {PropType<ModelIconProps>} */
    icon: {
      type: Object,
      default: () => new ModelIconProps(),
    },

    outlined: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    // TODO alterar o nome dessa prop para "closable" que faz mais sentido
    close: {
      type: Boolean,
      default: false,
    },

    maxCharacter: {
      type: Number,
      default: -1,
    },
  },

  computed: {
    computedLabel() {
      if (this.maxCharacter === -1) return this.label;

      return UtilsString.truncate(this.label, this.maxCharacter);
    },
  },

  methods: {
    onClick() {
      if (this.disabled || this.readonly) return;

      this.$emit('click');
    },
    onClose() {
      this.$emit('click:close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/tag.scss';
</style>
